import {
  Box,
  BoxProps,
  Center,
  Circle,
  Flex,
  SquareProps,
} from '@chakra-ui/react'

interface RadioButtonIProps extends BoxProps {
  isActive: boolean
  onClick: () => void
  label?: string
  disabled?: boolean
  radioButtonStyles?: SquareProps
  activeColor?: string
  radioLabelColor?: string
}

export const RadioButton = ({
  isActive,
  onClick,
  label,
  disabled = false,
  radioButtonStyles,
  activeColor = '#3279C7',
  radioLabelColor = '#44546F',
  ...rest
}: RadioButtonIProps) => {
  return (
    <Flex direction='row'>
      <Circle
        as='button'
        border={`2px solid ${activeColor}`}
        disabled={disabled}
        onClick={onClick}
        opacity={disabled ? 0.6 : 1}
        size='22px'
        {...radioButtonStyles}
      >
        <Center>
          {isActive ? (
            <Circle
              backgroundColor={activeColor}
              data-testid='RadioButton:center'
              h='12px'
              w='12px'
            />
          ) : null}
        </Center>
      </Circle>
      <Box
        color={radioLabelColor}
        fontSize='14px'
        fontWeight='500'
        ml={3}
        {...rest}
      >
        {label}
      </Box>
    </Flex>
  )
}
